<template>
  <div class="card mb-0 shadow">
    <div class="card-body">
      <div v-if="telaAtual === 'lista'" class="animate__animated animate__fadeIn">
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 no-print">
          <h4 class="font-weight-bold">Atividades</h4>
          <div>
            <b-button type="button" variant="primary" class="mr-2" :disabled="!item.id"
              @click="telaAtual = 'nova'"><i class="fas fa-plus-square"></i> Incluir nova atividade</b-button>
            <b-button type="button" variant="outline-dark" class="mr-2" @click="viewFilterReport = !viewFilterReport">
              <i class="fas fa-filter"></i> Filtros
            </b-button>
            <b-button type="button" variant="outline-dark" title="Imprimir página da listagem"
              :disabled="loadingAtividades || !!erro" @click="imprimirLista"><i class="fas fa-print"></i></b-button>
          </div>
        </div>

        <form v-if="viewFilterReport" class="mb-4 no-print" @submit.prevent="filtrar">
          <div class="row">
            <form-calendar v-model="data_inicio" grid="4" label="Data inicial" />
            <form-calendar v-model="data_fim" grid="4" label="Data final" />
            <form-select v-model="filtroStatus" label="Status" :itens="statusOptions" grid="4" />
            <form-input v-model="search" label="Buscar por atividade, protocolo, objetivo ou local:" />
          </div>
          <div class="d-flex justify-content-end">
            <b-button type="button" variant="secondary" size="sm" class="mr-2" @click="limparFiltros">Limpar filtros</b-button>
            <b-button type="submit" variant="success" size="sm">Filtrar</b-button>
          </div>
        </form>

        <b-alert v-if="erro" show variant="danger">{{ erro }}</b-alert>
        <load v-if="loadingAtividades" mode="table" />
        <div v-else>
          <print-content>
            <b-table :fields="campos" :items="AtividadesList" responsive striped hover
              show-empty small outlined stacked="xs" table-class="mb-3">
              <template v-slot:cell(protocolo)="data">
                Protocolo: <b>{{ data.item.protocolo }}</b><br />
                Atividade: <b>{{ data.item.atividade }}</b><br />
                Frequência: <b>{{ data.item.frequencia }}</b><br />
                Objetivo: <b>{{ data.item.objetivo }}</b><br />
                Local da atividade: <b>{{ data.item.local }}</b>
              </template>
              <template v-slot:cell(data_atividade)="data">
                {{ formatarDataHora(data.item.data_atividade, data.item.hora_atividade) }}
              </template>
              <template v-slot:cell(status)="data">
                <span :class="statusClasse(data.item.status)">{{ data.item.status }}</span>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button type="button" size="sm" variant="success" class="mr-2" title="Editar atividade"
                  @click="abrirEdicao(data.item)"><i class="mdi mdi-square-edit-outline"></i></b-button>
                <b-button type="button" size="sm" variant="primary" title="Visualizar e imprimir atividade"
                  @click="imprimirAtividade(data.item.id)"><i class="mdi mdi-eye"></i></b-button>
              </template>
              <template v-slot:empty>
                <div class="text-center my-4">Nenhuma atividade encontrada.</div>
              </template>
            </b-table>
          </print-content>
          <div class="d-flex flex-wrap justify-content-between align-items-center no-print">
            <div class="d-flex align-items-center">
              <select v-model.number="perPage" class="form-control mr-2" style="width: 75px"
                aria-label="Registros por página" @change="filtrar">
                <option :value="5">5</option><option :value="10">10</option>
                <option :value="25">25</option><option :value="50">50</option>
              </select>
              <b-pagination :value="page" :per-page="perPage" :total-rows="pagination.total"
                class="mb-0" @input="changePage" />
            </div>
            <span>Página {{ pagination.currentPage }} de {{ pagination.totalPages }}.
              Total: {{ pagination.total }} registro(s).</span>
          </div>
        </div>
      </div>

      <NovaAtividade v-else-if="telaAtual === 'nova'" :key="`nova-${item.id}`" :item="item"
        @voltar="voltarLista" @atividadeCriada="atividadeCriada" />
      <EditAtividade v-else-if="telaAtual === 'editar' && itemSelecionado" :key="itemSelecionado.id"
        :atividade="itemSelecionado" :item="item" @voltar="voltarLista" @atualizado="atualizarSelecionado" />
    </div>
  </div>
</template>

<script>
import NovaAtividade from './AtividadeCrianca.vue';
import EditAtividade from './EditAtividadeCrianca.vue';
import { API, ROTA_IMPRESSAO, opcoesStatus, statusClasse, dataApi,
  formatarDataHora, mensagemErro, imprimirConteudo, limparImpressaoAtividade } from './apoioAtividadesCrianca';

export default {
  name: 'AtividadesCrianca',
  components: { NovaAtividade, EditAtividade },
  props: { item: { type: Object, required: true } },
  data() {
    return {
      page: 1,
      perPage: 10,
      loadingAtividades: false,
      itemSelecionado: null,
      filtroStatus: '',
      data_inicio: null,
      data_fim: null,
      search: '',
      AtividadesList: [],
      pagination: { total: 0, currentPage: 1, totalPages: 1 },
      statusOptions: opcoesStatus(true),
      telaAtual: 'lista',
      viewFilterReport: false,
      erro: '',
      requisicao: 0,
      campos: [
        { key: 'protocolo', label: 'Detalhes' },
        { key: 'data_atividade', label: 'Data e hora' },
        { key: 'status', label: 'Status' },
        { key: 'actions', label: '', class: 'text-right no-print' },
      ],
    };
  },
  watch: {
    'item.id': {
      immediate: true,
      handler() {
        this.page = 1;
        this.telaAtual = 'lista';
        this.itemSelecionado = null;
        this.AtividadesList = [];
        this.getAtividades();
      },
    },
  },
  beforeDestroy() { this.requisicao += 1; limparImpressaoAtividade(); },
  methods: {
    formatarDataHora,
    statusClasse,
    abrirEdicao(atividade) {
      this.itemSelecionado = { ...atividade };
      this.telaAtual = 'editar';
    },
    atividadeCriada(atividade) { this.abrirEdicao(atividade); },
    atualizarSelecionado(atividade) {
      // Mantém a edição e a aba atual. A listagem é atualizada ao voltar.
      this.itemSelecionado = { ...atividade };
    },
    voltarLista() {
      this.telaAtual = 'lista';
      this.itemSelecionado = null;
      this.getAtividades();
    },
    filtrar() { this.page = 1; this.getAtividades(); },
    async getAtividades() {
      const requisicao = ++this.requisicao;
      this.erro = '';
      if (!this.item.id) {
        this.AtividadesList = [];
        this.pagination = { total: 0, currentPage: 1, totalPages: 1 };
        this.loadingAtividades = false;
        return;
      }
      this.loadingAtividades = true;
      try {
        const response = await axios.get(`${API}/buscar`, { params: {
          acolhimento_id: this.item.id,
          page: this.page,
          perPage: this.perPage,
          filtroStatus: this.filtroStatus || null,
          data_inicio: dataApi(this.data_inicio) || null,
          data_fim: dataApi(this.data_fim) || null,
          search: this.search || null,
        } });
        if (requisicao !== this.requisicao) return;
        const dados = response.data;
        this.AtividadesList = dados.data.data || [];
        this.pagination = dados.pagination;
        if (this.page > this.pagination.totalPages) {
          this.page = this.pagination.totalPages;
          await this.getAtividades();
        }
      } catch (erro) {
        if (requisicao !== this.requisicao) return;
        this.AtividadesList = [];
        this.pagination = { total: 0, currentPage: 1, totalPages: 1 };
        this.erro = mensagemErro(erro, 'Erro ao carregar as atividades.');
      } finally {
        if (requisicao === this.requisicao) this.loadingAtividades = false;
      }
    },
    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
        this.page = page;
        this.getAtividades();
      }
    },
    limparFiltros() {
      this.search = '';
      this.filtroStatus = '';
      this.data_inicio = null;
      this.data_fim = null;
      this.filtrar();
    },
    imprimirAtividade(id) {
      this.$router.push({ name: ROTA_IMPRESSAO, params: { id } });
    },
    imprimirLista() { imprimirConteudo(this); },
  },
};
</script>

<style>
@media screen {
  #print[data-acolhimento-atividade="1"] {
    display: none;
  }
}

@media print {
  body.imprimindo-atividade-acolhimento * {
    visibility: hidden;
  }

  body.imprimindo-atividade-acolhimento #print,
  body.imprimindo-atividade-acolhimento #print * {
    visibility: visible;
  }

  body.imprimindo-atividade-acolhimento #print {
    display: block;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  body.imprimindo-atividade-acolhimento #print .no-print {
    display: none !important;
  }
}
</style>
